<template>
	<div class="block-pagination">
		<br/>
		<div class="row blockcont" v-if="total > 0 && totalPages > 0">
			<div class="col-xs-3">
                <span class="selectwrap" v-if="showPerPage">
                    <select v-model="perPagePaginate" >
                        <option :value="index" v-for="(perPage,index) in selectPerPage">{{perPage}}</option>
                    </select>
                </span>
			</div>

			<div class="col-xs-9 pagenav" style="text-align: right;">
                <span :disabled="isInFirstPage" @click="onClickFirstPage">
                    <a :disabled="isInFirstPage" href="javascript:void(0)">&laquo;</a>
                </span>
				<!--<span  @click="onClickPreviousPage"-->
				<!--:disabled="isInFirstPage"><a :disabled="isInFirstPage" href="javascript:void(0)">&laquo;</a></span>-->

				<span @click="onClickPage(p.name)" v-for="p in pages" :class="{'current' : (page == p.name)}"
							:key="p.name">
                    <a href="javascript:void(0)">{{p.name}}</a>
                </span>

				<!--<span   @click="onClickNextPage"-->
				<!--:disabled="isInLastPage"><a  :disabled="isInLastPage" href="javascript:void(0)">&raquo;</a></span>-->
				<span @click="onClickLastPage"
							:disabled="isInLastPage"><a :disabled="isInLastPage" href="javascript:void(0)">&raquo; </a></span>
			</div>
		</div>

	</div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5
    },
    perPage: {
      type: Number,
      required: false,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true,
      default: 0
    },
    showPerPage: {
      type: Boolean,
      required: false,
      default: true
    },
    dataSelectPage: {
      type: Object,
      required: false,
      default: null
    }
  },
  components: {},
  data () {
    return {
      perPagePaginate: 10,
      page: 1,
      selectPerPage: {
        10: '10 per page',
        20: '20 per page',
        50: '50 per page'
      },
      firstLoad: false
    }
  },
  created () {
    this.page = this.currentPage
    this.perPagePaginate = this.perPage
    if (this.dataSelectPage) {
      this.selectPerPage = JSON.parse(JSON.stringify(this.dataSelectPage))
    }
  },
  computed: {
    startPage () {
      // When on the first page
      if (this.page === 1) {
        return 1
      }
      // When on the last page
      if (this.page === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons + 1
      }

      let subPage = parseInt(this.maxVisibleButtons / 2)

      if (this.page - subPage <= 0) {
        return 1
      } else {
        if (this.page - subPage + this.maxVisibleButtons > this.totalPages) {
          return this.totalPages - this.maxVisibleButtons + 1
        }
        return this.page - subPage
      }
    },
    pages () {
      const range = []
      for (let i = this.startPage;
				     i < (this.startPage + this.maxVisibleButtons);
				     i += 1) {
        if (i > 0 && i <= this.totalPages) {
          range.push({
            name: i,
            isDisabled: i === this.page
          })
        }
      }

      return range
    },
    isInFirstPage () {
      return this.page === 1
    },
    isInLastPage () {
      return this.page === this.totalPages
    }
  },
  watch: {
    'currentPage' (newVal, oldVal) {
      if (Number(newVal) !== this.page) {
        this.page = newVal
      }
    },
    'perPagePaginate' (newValue, oldValue) {
      if (this.firstLoad) {
        this.page = 1
        this.$emit('updatePerPage', {
          currentPage: this.page,
          perPage: Number(newValue)
        })
      }
    }
  },
  updated () {
    this.firstLoad = true
  },
  methods: {
    onClickFirstPage () {
      if (this.page != 1) {
        this.page = 1
        this.emitData()
      }
    },
    onClickPreviousPage () {
      if (this.page > 1) {
        this.page = this.page - 1
        this.emitData()
      }
    },
    onClickPage (page) {
      if (this.page != page) {
        this.page = page
        this.emitData()
      }
    },
    onClickNextPage () {
      if (this.page < this.totalPages) {
        this.page = this.page + 1
        this.emitData()
      }
    },
    onClickLastPage () {
      if (this.page != this.totalPages) {
        this.page = this.totalPages
        this.emitData()
      }
    },
    emitData () {
      this.$emit('updatePerPage', {
        currentPage: this.page,
        perPage: this.perPage
      })
    }
  }

}
</script>
<style scoped="">
    .block-pagination select {
        padding: 10px !important;
    }
</style>
